import { readScore, scoreBytesToXml, type ParsedScore } from '@corocanto/scoring';
import { useMemo } from 'react';
import { useSong, useSongFile } from './songs';

/** A song with its MusicXML text and parsed score (the browser parses; the server only stores). */
export function useParsedSong(choirId: string | undefined, songId: string | undefined) {
  const song = useSong(choirId, songId);
  const file = useSongFile(choirId, songId);
  const parsed = useMemo((): { xml: string; score: ParsedScore } | null => {
    if (!file.data) return null;
    try {
      const xml = scoreBytesToXml(file.data);
      return { xml, score: readScore(xml) };
    } catch {
      return null;
    }
  }, [file.data]);
  return {
    song: song.data,
    parsed,
    isPending: song.isPending || file.isPending,
    isError: song.isError || file.isError || (!!file.data && !parsed),
    refetch: () => Promise.all([song.refetch(), file.refetch()]),
  };
}
